// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__249Qb","info":"PatientInfo_info__Z_tas"};